import styled from "styled-components";

export const CouponPageStyle = styled.div`
  .btn-div {
    justify-content: end;
    display: flex;
  }

  .form-button {
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    color: white;
    font-family: light-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 13px;
    align-self: center;
  }

  .table-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }

  .table-item2 {
    font-family: light-pro, sans-serif;
  }

  .table-div {
    padding: 20px;
    width: 80%;
    display: flex;
    height: 540px;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }

  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  .export-icon-style {
    cursor: pointer;
    font-weight: bold;
    color: #f28809;
  }

  .action-items {
    display: flex;
    justify-content: space-between;
    width: 80%;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }

  .edit-icon {
    font-size: 20px;
    color: #4cdb4c;
  }

  .view-icon {
    font-size: 20px;
    color: #f28809;
  }

  .delete-icon {
    font-size: 20px;
    color: #dd3e3e;
  }

  .table-loading {
    text-align: center;
    font-size: 1rem;
  }
  .table-item {
    font-size: 1rem;
  }
  @media screen and (max-width: 600px) {
    .table-div {
      width: 100%;
    }
  }

  @media screen and (max-width: 1024px) {
    .form-button {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 500px) {
    .form-button {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .table-item {
      font-size: 0.7rem;
    }
  }
`;
